const config = {
  blockCheck: true,
  mbAudioItemData: [
    {
      id: 'a01',
      src: 'games/page022_game0/audio/29_car.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page022_game0/img/audioOn.png', iconOff: 'games/page022_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -50,
        x: 67,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page022_game0/audio/30_doll.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page022_game0/img/audioOn.png', iconOff: 'games/page022_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -50,
        x: 100,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page022_game0/audio/31_ball.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page022_game0/img/audioOn.png', iconOff: 'games/page022_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -25,
        x: 67,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: 'games/page022_game0/audio/32_robot.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page022_game0/img/audioOn.png', iconOff: 'games/page022_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: -50,
        x: 67,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
  ],
  mainImage: {
    src: 'games/page022_game0/img/bcg.webp',
  },

  multiconnect: false,
  globalItemsConfig: {
    hookPoint: {
      rad: 0,
    },
  },
  dontCheckIncorrectLines: false,
  dontAcceptIncorrectLines: true,

  linesStyle: {
    colors: {
      bad: 'red',
      good: 'green',
      neutral: '#4cb9fa',
    },
    size: 5,
  },
  rules: [
    { connectId: 1, connectedWith: 5 },
    { connectId: 2, connectedWith: 6 },
    { connectId: 3, connectedWith: 7 },
    { connectId: 4, connectedWith: 8 },
  ],

  autoCheck: true,
  numberOfGoodLines: 3,
  sounds: [
    { src: 'games/page022_game0/audio/false.mp3', id: 'endConnect' },
    { src: 'games/page022_game0/audio/click.mp3', id: 'startConnect' },
    { src: 'games/page022_game0/audio/29_car.mp3', id: 'car' },
    { src: 'games/page022_game0/audio/30_doll.mp3', id: 'doll' },
    { src: 'games/page022_game0/audio/31_ball.mp3', id: 'ball' },
    { src: 'games/page022_game0/audio/32_robot.mp3', id: 'robot' },
  ],
  groups: [
    {
      name: 'left',
      disableShuffle: false,
      items: [
        {
          connectId: 1,
          audioId: 'car',
          image: { src: 'games/page022_game0/img/car.png' },
          imageStyle: { position: 'absolute', width: '229px', height: '241px' },
          pos: {
            x: 76,
            y: 429,
            width: 229,
            height: 241,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [
            { x: 1, y: 120 },
            { x: 191, y: 120 },
          ],
        },
        {
          connectId: 2,
          audioId: 'doll',
          image: { src: 'games/page022_game0/img/doll.png' },
          imageStyle: { position: 'absolute', width: '228px', height: '241px' },
          pos: {
            x: 76,
            y: 682,
            width: 228,
            height: 241,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [
            { x: 1, y: 120 },
            { x: 191, y: 120 },
          ],
        },
        {
          connectId: 3,
          audioId: 'ball',
          image: { src: 'games/page022_game0/img/ball.png' },
          imageStyle: { position: 'absolute', width: '229px', height: '241px' },
          pos: {
            x: 1608,
            y: 429,
            width: 229,
            height: 241,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [
            { x: 1, y: 120 },
            { x: 229, y: 120 },
          ],
        },
        {
          connectId: 4,
          audioId: 'robot',
          image: { src: 'games/page022_game0/img/robot.png' },
          imageStyle: { position: 'absolute', width: '229px', height: '240px' },
          pos: {
            x: 1608,
            y: 682,
            width: 229,
            height: 240,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [
            { x: 1, y: 120 },
            { x: 191, y: 120 },
          ],
        },
      ],
    },
    {
      name: 'right',
      disableShuffle: true,
      items: [
        {
          audio: 'a01',
          connectId: 5,
          image: { src: 'games/page022_game0/img/car_t.png' },
          imageStyle: { position: 'absolute', width: '135px', height: '94px' },
          pos: {
            x: 552,
            y: 937,
            width: 174,
            height: 94,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [
            { x: 17, y: 72 },
            { x: 174 - 17, y: 72 },
          ],
        },
        {
          audio: 'a02',
          connectId: 6,
          image: { src: 'games/page022_game0/img/doll_t.png' },
          imageStyle: { position: 'absolute', width: '174px', height: '221px' },
          pos: {
            x: 791,
            y: 458,
            width: 174,
            height: 221,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [
            { x: 38, y: 143 },
            { x: 174 - 75, y: 162 },
          ],
        },
        {
          audio: 'a03',
          connectId: 7,
          image: { src: 'games/page022_game0/img/ball_t.png' },
          imageStyle: { position: 'absolute', width: '170px', height: '171px' },
          pos: {
            x: 954,
            y: 136,
            width: 174,
            height: 221,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [
            { x: 20, y: 165 },
            { x: 174 - 18, y: 165 },
          ],
        },
        {
          audio: 'a04',
          connectId: 8,
          image: { src: 'games/page022_game0/img/robot_t.png' },
          imageStyle: { position: 'absolute', width: '125px', height: '216px' },
          pos: {
            x: 820,
            y: 776,
            width: 174,
            height: 221,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [
            { x: 24, y: 98 },
            { x: 174 - 23, y: 95 },
          ],
        },
      ],
    },
  ],
};
export default config;
